import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { ReactComponent as ConfirmEmailIcon } from '../../../../../assets/img/confirm-email-icon.svg';
import { recruiterAppActions } from '../../../../../redux/slices/recruiterAppSlice';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';

import './styles.scss';

export const Confirmation = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { email, emailCode },
        errors,
    } = useAppSelector((state) => state.recruiterAppSignUp);

    const verificationCodeChangeHandler = (value: unknown) => {
        dispatch(signUpActions.setField({ id: 'emailCode', value }));
    };

    const submitResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(recruiterAppActions.sendConfirmationCode(email, recaptchaToken, callback));
    };

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(signUpActions.submitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='recruiter-signup-confirmation'>
            <ConfirmEmailIcon className='recruiter-signup-confirmation__icon' />
            <h2 className='recruiter-signup-confirmation__title'>{__t('Подтвердите email')}</h2>
            <p className='recruiter-signup-confirmation__text'>{__t('Последний шаг, чтобы создать профиль.')}</p>
            <ConfirmationComponent
                codeValue={emailCode || ''}
                confirmationMethod='email'
                text={
                    <>
                        {__t('Введите код, который мы отправили на')}&nbsp;<strong>{email}</strong>
                    </>
                }
                codeErrors={errors?.emailCode}
                changeConfirmationValueErrors={errors?.email}
                updateModalText={__t('На которий мы отправим код для подтверждения')}
                verificationCodeChangeHandler={verificationCodeChangeHandler}
                submitResendCode={submitResendCode}
                submitChangeConfirmationValue={submitChangeConfirmationValue}
            />
        </div>
    );
};
